import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class TextProps {
  @Inlet(Accepts.Image) public headerImage?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public text!: Types["MarkdownText"];
}

export const TextDefinition = defineElement("text", TextProps, {
  versionRequired: "0.8.0",
});
